import { useEffect, useRef, useState } from 'react';
import { Formik, Form, Field, FieldArray, ErrorMessage, useFormikContext } from 'formik';
import { KeenIcon, DefaultTooltip, LazyFormikSelect, DatePicker, CustomOption, CustomSingleValue } from '@/components';
import { useLazyOptions } from '@/hooks';
import { toast } from 'sonner';
import itemService from '@/services/billing/itemService';
import taxService from '@/services/billing/taxService';
import userService from '@/services/setting/userService';
import { calculateSubtotal } from '@/utils';
import { PriceInput } from '@/components/form';
import { useAbility } from '@/providers/';
import { Can } from '@casl/react';
import { useUserOptions, useTaxOptions, useItemOptions } from '@/hooks'

const Items = ({ openModal, loadOnChange }) => {
    const { values, setFieldValue } = useFormikContext();
    const [dataLoading, setDataLoading] = useState(false);
    const [itemData, setItemData] = useState([])
    const [userData, setuserData] = useState([]);
    const itemsSettings = values.template_Settings?.items // items
    const [selectedData, setSelectedData] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const formikRef = useRef();
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState('create');
    const { ability } = useAbility();
    const [loading, setLoading] = useState(false)
    const [itemId, setItemId] = useState(null)
    // const itemsSettings = values.template_Settings?.items
    const loadUserOptions = useUserOptions({ defaultPageSize: 20 });
    const loadTaxOptions = useTaxOptions({ defaultPageSize: 20 });
    const loadItemOptions = useItemOptions({ defaultPageSize: 20 });

    // useEffect(() => {
    //     resetItems();
    // }, [loadOnChange]);

    return (
        <>
            <div className='flex items-center my-5'>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
                <p className='text-sm px-4'>Items</p>
                <span className='w-1/2 h-0.5 border border-dashed inline-block'></span>
            </div>
            <div>
                <FieldArray name="time_entries" className="card">
                    {({ push, remove }) => (
                        <>
                            {values.time_entries.map((_, index) => (
                                <div key={index} className=''>
                                    <div className='flex items-center justify-between mb-3'>
                                        <div className='flex items-center'>
                                            <span className='w-12 h-0.5 bg-border inline-block mr-2'></span>
                                            <h4 className='text-sm'>Item #{index + 1}</h4>
                                        </div>
                                        <div className='flex items-center gap-1.5'>
                                            {/* {index === 0 && values.time_entries.length < 10 && (
                                        <button
                                            type="button"
                                            className="text-xs btn btn-sm btn-light"
                                            onClick={() =>
                                            push({
                                                item_id: '',
                                                item: null,
                                                description: '',
                                                billed_by: '',
                                                billed_by_user: null,
                                                quantity: 1,
                                                rate: '',
                                                date: new Date().toISOString().split('T')[0],
                                                tax: [],
                                            })
                                            }
                                        >
                                            <KeenIcon icon="plus" />
                                            Add Item
                                        </button>
                                    )} */}
                                            <button type="button" className='btn btn-sm btn-danger btn-outline my-2' onClick={() => remove(index)}>
                                                <KeenIcon icon="trash" />
                                                Remove
                                            </button>
                                            {/* {values.time_entries.length > 1 && (
                                    )} */}
                                        </div>
                                    </div>
                                    {/* grid md:grid-cols-4 sm:grid-cols-2 */}
                                    <div className="rounded-md p-1.5 flex flex-nowrap">
                                        <div className='invoice-select-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{itemsSettings?.items_label || 'Item'} </label>
                                            <LazyFormikSelect
                                                name={`time_entries[${index}].item_id`}
                                                loadOptions={loadItemOptions}
                                                pageSize={20}
                                                preloadedOption={values.time_entries[index]?.item}
                                                transparent={true}
                                                // customClassNames={{
                                                //     menuList: '!max-h-[120px]',
                                                // }}
                                                noOptionsMessage={() => (
                                                    isLoading ? (
                                                        <span className="text-sm">Loading...</span>
                                                    ) : (
                                                        <div>
                                                            <span className="text-sm mr-1">No options available</span>
                                                            <Can I='create' a='item' ability={ability}>
                                                                <button type="button"
                                                                    onClick={openModal}
                                                                    className="link block mx-auto"
                                                                >
                                                                    Add new
                                                                </button>
                                                            </Can>
                                                        </div>
                                                    )
                                                )}
                                                onOptionSelect={(selected) => {
                                                    console.log('selected', selected)
                                                    if (selected?.id) {
                                                        // The seeded items are priced 0.00; leave the rate blank instead of $0.00 (OL-184).
                                                        const isValidRate = Number(selected?.price) > 0 ? selected.price : '';
                                                        setFieldValue(`time_entries[${index}].rate`, isValidRate);
                                                    }
                                                }}
                                            />
                                            <ErrorMessage
                                                name={`time_entries[${index}].item_id`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-date-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{itemsSettings?.date_label || 'Date'}</label>
                                            <Field name={`time_entries[${index}].date`} component={DatePicker} isRange={false} transparent={true} />
                                            <ErrorMessage
                                                name={`time_entries[${index}].date`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-date-w'>
                                            <label className="form-label mb-1.5 pl-1.5">To</label>
                                            <Field name={`time_entries[${index}].date_to`} component={DatePicker} isRange={false} transparent={true} />
                                            <ErrorMessage name={`time_entries[${index}].date_to`} component="div" className="text-red-500 text-[11px] mt-1" />
                                        </div>
                                        <div className='invoice-select-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{itemsSettings?.billed_by_label || 'Billed By'} </label>
                                            <LazyFormikSelect
                                                name={`time_entries[${index}].billed_by`}
                                                loadOptions={loadUserOptions}
                                                pageSize={20}
                                                preloadedOption={values.time_entries[index].billed_by_user}
                                                transparent={true}
                                                components={{
                                                    Option: CustomOption,
                                                    SingleValue: CustomSingleValue,
                                                }}
                                            />
                                            <ErrorMessage
                                                name={`time_entries[${index}].billed_by`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-price-w shrink-0'>
                                            <label className="form-label mb-1.5 pl-1.5">{itemsSettings?.hours_label || 'Hours'}</label>
                                            <Field className="input transparent-input no-spinner" type="number" name={`time_entries[${index}].quantity`} />
                                            <ErrorMessage
                                                name={`time_entries[${index}].quantity`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        <div className='invoice-rate-w shrink-0 overflow-x-hidden'>
                                            <label className="form-label mb-1.5 pl-1.5">{itemsSettings?.rate_label || 'Price'}</label>
                                            <PriceInput name={`time_entries[${index}].rate`} prefix="$" className="transparent-input" />
                                        </div>
                                        <div className='invoice-rate-w shrink-0'>
                                            <label className="form-label mb-1.5 pl-1.5">{itemsSettings?.subtotal_label || 'Sub'}</label>
                                            <div className='input transparent-input'>
                                                {calculateSubtotal(values.time_entries[index].rate, values.time_entries[index].quantity)}
                                            </div>
                                            {/* <Field className="input" type="text" name={`items[${index}].price`} /> */}
                                        </div>
                                        <div className='invoice-tax-w !w-[230px]'>
                                            <label className="form-label mb-1.5 pl-1.5">{itemsSettings?.tax_label || 'Tax'}</label>
                                            <LazyFormikSelect
                                                name={`time_entries[${index}].tax`}
                                                loadOptions={loadTaxOptions}
                                                pageSize={20}
                                                // options={taxOptions}
                                                // customClassNames={{
                                                //     menuList: '!max-h-[120px]',
                                                // }}
                                                // onFocus={() => loadTax(null)}
                                                // isLoading={taxLoading}
                                                isMulti={true}
                                                transparent={true}
                                                returnFullObject
                                                preloadedOption={values.time_entries[index].taxes?.length > 0 ? values.time_entries[index].taxes : []}
                                            // preloadedOption={values.tax[0].item}
                                            />
                                            <ErrorMessage
                                                name={`time_entries[${index}].tax`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                        {/* <div className='invoice-tax-w !w-[165px]'>
                                    <label className="form-label mb-1.5 pl-1.5">{itemsSettings?.tax2_label || 'Tax 2'}</label>
                                    <LazyFormikSelect
                                        name={`items[${index}].tax2`}
                                        options={taxOptions}
                                        // placeholder="Select Tax"
                                        onFocus={() => loadTax(null)}
                                        isLoading={taxLoading}
                                        transparent={true}
                                        returnFullObject
                                        preloadedOption={values.items[index].tax2}
                                        // preloadedOption={values.tax[0].item}
                                    />
                                    <ErrorMessage
                                        name={`items[${index}].tax2`}
                                        component="div"
                                        className="text-red-500 text-[11px] mt-1"
                                    />
                                </div> */}
                                        <div className='invoice-description-w'>
                                            <label className="form-label mb-1.5 pl-1.5">{itemsSettings?.description_label || 'Description'}</label>
                                            <Field as="textarea" className="input transparent-input pt-2 text-xs overflow-auto custom-scrollbar" name={`time_entries[${index}].description`} />
                                            <ErrorMessage
                                                name={`time_entries[${index}].description`}
                                                component="div"
                                                className="text-red-500 text-[11px] mt-1"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                            {/* No row limit (OL-200). The button sits under the last row, so a new row opens where the user is. */}
                            <div className='flex items-center justify-end'>
                                <button type="button" className='text-xs btn btn-sm btn-light' onClick={() => push({
                                    item_id: '',
                                    item: null,
                                    description: '',
                                    billed_by: '',
                                    billed_by_user: null,
                                    quantity: null,
                                    rate: '',
                                    date: '', //new Date().toISOString().split('T')[0]
                                    tax: [],
                                })}>
                                    <KeenIcon icon="plus" />
                                    Add Items
                                </button>
                            </div>
                        </>
                    )}
                </FieldArray>
            </div>
        </>
    )
}

export { Items }